module.exports = __webpack_public_path__ + "img/SQL.476f81a1.png";